var _mask, _g, _defs;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCircle(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 120,
    viewBox: "0 0 168 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "mobile_navigation__circle_mask0",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 168,
    height: 120
  }, /*#__PURE__*/React.createElement("rect", {
    width: 168,
    height: 120,
    fill: "#C4C4C4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mobile_navigation__circle_mask0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.091 109.523C11.1912 109.523 -17.8028 97.476 -39.6505 75.6283C-61.4981 53.7807 -73.5449 24.7867 -73.5449 -6.11311C-73.5449 -37.0129 -61.4981 -66.0069 -39.6505 -87.8546C-17.8028 -109.702 11.1912 -121.749 42.091 -121.749C72.9907 -121.749 101.985 -109.702 123.832 -87.8546C145.68 -66.0069 157.727 -37.0129 157.727 -6.11311C157.727 24.7867 145.68 53.7807 123.832 75.6283C101.985 97.476 72.9907 109.523 42.091 109.523ZM42.091 -119.571C-20.4572 -119.571 -71.367 -68.6613 -71.367 -6.11311C-71.367 56.4351 -20.4572 107.413 42.159 107.413C104.707 107.413 155.685 56.5032 155.685 -6.11311C155.617 -68.6613 104.707 -119.571 42.091 -119.571Z",
    fill: "url(#mobile_navigation__circle_paint0_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.4046 99.4498C13.2326 99.4498 -16.1018 87.3349 -38.1536 65.2831C-60.2054 43.2313 -72.3203 13.8969 -72.3203 -17.2751C-72.3203 -48.4471 -60.2054 -77.7815 -38.1536 -99.8333C-16.1018 -121.885 13.2326 -134 44.4046 -134C75.5766 -134 104.911 -121.885 126.963 -99.8333C149.015 -77.7815 161.129 -48.4471 161.129 -17.2751C161.129 13.8969 149.015 43.2313 126.963 65.2831C104.911 87.3349 75.5766 99.4498 44.4046 99.4498ZM44.4046 -133.115C-19.5049 -133.115 -71.4355 -81.1165 -71.4355 -17.2751C-71.4355 46.5663 -19.4368 98.565 44.4046 98.565C108.314 98.565 160.245 46.5663 160.245 -17.2751C160.245 -81.1165 108.314 -133.115 44.4046 -133.115Z",
    fill: "url(#mobile_navigation__circle_paint1_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.7249 120.004C-0.447121 120.004 -29.7815 107.889 -51.8333 85.8375C-73.8851 63.7857 -86 34.4513 -86 3.27934C-86 -27.8927 -73.8851 -57.227 -51.8333 -79.2789C-29.7815 -101.331 -0.447121 -113.446 30.7249 -113.446C61.8969 -113.446 91.2312 -101.331 113.283 -79.2789C135.335 -57.227 147.45 -27.8927 147.45 3.27934C147.45 34.4513 135.335 63.7857 113.283 85.8375C91.2312 107.821 61.8969 120.004 30.7249 120.004ZM30.7249 -112.629C-33.1845 -112.629 -85.1152 -60.6301 -85.1152 3.21127C-85.1152 67.1207 -33.1165 119.051 30.7249 119.051C94.5663 119.051 146.565 67.0526 146.565 3.21127C146.565 -60.6301 94.6343 -112.629 30.7249 -112.629Z",
    fill: "url(#mobile_navigation__circle_paint2_linear)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.1429 111.36C19.9708 111.36 -9.36351 99.2456 -31.4153 77.1937C-53.4671 55.1419 -65.582 25.8075 -65.582 -5.36446C-65.582 -36.5365 -53.4671 -65.8708 -31.4153 -87.9226C-9.36351 -109.974 19.9708 -122.089 51.1429 -122.089C82.3149 -122.089 111.649 -109.974 133.701 -87.9226C155.753 -65.8708 167.868 -36.5365 167.868 -5.36446C167.868 25.8075 155.753 55.1419 133.701 77.1937C111.649 99.2456 82.3149 111.36 51.1429 111.36ZM51.1429 -121.205C-12.7666 -121.205 -64.6972 -69.2058 -64.6972 -5.36446C-64.6972 58.545 -12.6985 110.476 51.1429 110.476C115.052 110.476 166.983 58.4769 166.983 -5.36446C166.983 -69.2739 115.052 -121.205 51.1429 -121.205Z",
    fill: "url(#mobile_navigation__circle_paint3_linear)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobile_navigation__circle_paint0_linear",
    x1: -73.514,
    y1: -6.09406,
    x2: 157.73,
    y2: -6.09406,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobile_navigation__circle_paint1_linear",
    x1: -72.3221,
    y1: -17.2503,
    x2: 161.111,
    y2: -17.2503,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobile_navigation__circle_paint2_linear",
    x1: -85.9987,
    y1: 3.25476,
    x2: 147.434,
    y2: 3.25476,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "mobile_navigation__circle_paint3_linear",
    x1: -65.566,
    y1: -5.35364,
    x2: 167.866,
    y2: -5.35364,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A86B1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1116,
    stopColor: "#C49642"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2229,
    stopColor: "#DAB960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3275,
    stopColor: "#EBD275"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4228,
    stopColor: "#F5E182"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#F8E687"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6151,
    stopColor: "#F6E181"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7707,
    stopColor: "#F1D370"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9485,
    stopColor: "#E9BD54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E6B54A"
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircle);
export default __webpack_public_path__ + "static/media/circle.e6676deb.svg";
export { ForwardRef as ReactComponent };